import { Component, ViewEncapsulation } from '@angular/core';
import { appRoutes } from 'src/app';
@Component({
  selector: 'hb-custom-footer',
  templateUrl: 'customFooter.component.html',
  styleUrls: ['./customFooter.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class CustomFooterComponent {
  public anexoFiscalUrl = `${window.location.protocol}//${window.location.host}/documents/AnexosFiscalEstadosCuenta.pdf`;
  public privacyAdvice = appRoutes.privacyAdvice;
}
